<template >
    <div class="replace-card-dialog">
        <el-dialog :visible.sync="visible" :title="$t('Member.bu')" left >
            <div class="replace-dialog-title mg-10">
                <div style="width: 70%;">
                    <p class="replace-dialog-title-p">
                        <span class="update-title-span">
                            {{ $t('Common.name') }}：{{ contractInfo.clientName }}
                        </span>
                        <span class="update-title-span1">
                            {{ $t('Common.phone') }}：{{ contractInfo.clientPhone }}
                        </span>
                    </p>
                    <p class="replace-dialog-title-p">
                        <span class="update-title-span">
                            {{ $t('Contract.number') }}：{{ contractInfo.contractNum }}
                        </span>
                        <span class="update-title-span1">
                            {{ $t('Contract.card_name') }}：{{ contractInfo.cardName }}
                        </span>
                    </p>
                    <p class="replace-dialog-title-p">
                        {{ $t('Contract.start_end_date') }}：{{ contractInfo.validityPeriod }}
                    </p>
                    <p class="replace-dialog-title-p">
                        <span class="update-title-span ">
                            {{ $t('Sell.standard_amount') }}：{{ contractInfo.baseAmtStr}}
                        </span>
                        <span class="update-title-span1 ">
                            {{ $t('Member.saler') }}：{{ contractInfo.contractSalesStaffNickname }}
                        </span>
                    </p>
                    <p class="replace-dialog-title-p">
                        {{ $t('Sell.Charge.paid_amount') }}：{{contractInfo.paidAmtStr}}
                    </p>
                </div>
            </div>

            <el-form
                ref="form"
                :model="form"
                :rules="rules"
                :status-icon="true"
                label-position="right"
                label-width="130px"
                label-suffix=":">
                <div class="replace-dialog-title mg-10" style="max-height: ">
                    <el-form-item :label="$t('Client.old_card_number')">
                        {{contractInfo.cardNum}}
                    </el-form-item>
                    <el-form-item :label="$t('Client.bind_new_psy')">
                        <el-input
                            v-if="!isNext"
                            type="text"
                            v-model="form.cardPhysicalId"
                            :placeholder="$t('Client.click_duka')"
                        />
                        <template v-if="isNext">{{ form.cardPhysicalId }}</template>
                    </el-form-item>
                    <el-form-item :label="$t('Sell.Dialog.new_member_card')" prop="cardNum">
                        <el-select
                            v-if="!isNext"
                            style="width: 100%;"
                            v-model="form.cardNum"
                            filterable
                            remote
                            reserve-keyword
                            :placeholder="$t('Fill.new_card')"
                            :remote-method="fetchCard"
                            @change="selectCard">
                            <el-option
                                v-for="item in memberCards"
                                :key="item.id"
                                :label="item.cardNumber"
                                :value="item.cardNumber">
                            </el-option>
                        </el-select>
                        <template v-if="isNext">{{ form.cardNum }}</template>
                    </el-form-item>
                    <el-form-item :label="$t('Reception.Fifth.fee')" prop="money">
                        <el-input
                            :placeholder="$t('Fill.fill_fee')"
                            type="number"
                            v-model="form.money"
                            v-if="!isNext"/>
                        <template v-if="isNext">{{ form.money }}</template>
                    </el-form-item>
                </div>
                <el-form-item :label="$t('Sell.Pay.title')" v-if="isNext">
                    <el-radio-group v-model="form.payMethodCode">
                        <el-radio :label="1">{{ $t('Sell.Pay.cash') }}</el-radio>
                        <el-radio :label="2">{{ $t('Sell.Pay.swipe') }}</el-radio>
                        <el-radio :label="3">{{ $t('Sell.Pay.bank') }}</el-radio>
                        <el-radio :label="4">{{ $t('Sell.Pay.alipay') }}</el-radio>
                        <el-radio :label="5">{{ $t('Sell.Pay.wechat') }}</el-radio>
                        <el-radio :label="8">{{ $t('Sell.Pay.other') }}</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer"  style="text-align:center">
                <el-button @click="submit" type="primary">
                    {{ !isNext ? $t('Common.next_step') : $t('Common.carry_out') }}
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

import {
    Dialog,
    DatePicker,
    RadioGroup,
    Radio,
    Row,
} from 'element-ui';
import PayForm from '@/components/Dialog/Client/PayForm';
import filterRole from '@/mixins/filterRole.js';

export default {
    components: {
        ElDialog: Dialog,
        ElDatePicker: DatePicker,
        ElRadioGroup: RadioGroup,
        ElRadio: Radio,
        ElRow: Row,
        PayForm,
    },
    mixins: [filterRole],
    data() {
        return {
            isNext: false,
            contractInfo: {},
            loading: false,
            visible: false,
            form: {
                cardStoreId: null,
                cardNum: null,
                cardPhysicalId: null,
                money: null,
                payMethodCode: 1,
            },
            rules: {
                cardNum: { required: true, message: this.$t('Fill.new_card') },
                money: { required: true, message: this.$t('Fill.fill_fee') },
            },
            contractNum: null,
            memberCards: [],
        };
    },
    watch: {},
    computed: {},
    methods: {
        resetForm() {
            this.memberCards = [];
            this.form = {
                cardStoreId: null,
                cardNum: null,
                cardPhysicalId: null,
                money: null,
                payMethodCode: 1,
            };
            setTimeout(() => {
                this.$refs.form.resetFields();
            }, 0);
        },
        open(data) {
            this.contractNum = data.contractNum;
            this.fetchContract();
        },
        fetchContract() {
            API.get(`contract/mshp/${this.contractNum}`)
            .then(res => {
                this.contractInfo = res;
                this.form.cardStoreId = res.storeId;
                this.visible = true;
            });
        },
        fetchCard(val = '') {
            API.get('card-number-setting/pages', {
                params: {
                    keyword: val,
                    storeIds: this.contractInfo.storeId,
                    status: 1,
                },
            }).then(res => {
                this.memberCards = res.content;
            });
        },
        selectCard() {
            this.form.cardPhysicalId = this.memberCards.find(el => el.cardNumber === this.form.cardNum).physicalId;
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                if (!this.isNext && !this.form.money) this.postData();
                else if (!this.isNext && this.form.money) this.isNext = true;
                else if (this.isNext) this.postData();
            });
        },
        postData() {
            const form = Object.assign({}, this.form);
            API.post(`contract/mshp/${this.contractNum}/reissue`, form)
            .then(() => {
                this.visible = false;
                $ele.$confirm(this.$t('Message.success'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    cancelButtonText: this.$t('Sell.small_print'),
                    type: 'warning',
                })
                .then(() => {
                    this.$emit('fetchData');
                })
                .catch(() => {
                    // 小票打印预览...跳转
                    if (!this.$$filterPermission('售卖-合同管理-小票打印')) return this.$router.push('/403');
                    const location = window.location;
                    const link = `${location.origin}/admin/ticket?contractNum=${this.contractNum}&activeName=member`;
                    window.open(link);
                });
            });
        },
    },
};
</script>

<style lang="scss">
.replace-card-dialog {
    .el-dialog {
        width: 710px;
        margin: 0 !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        overflow-y: auto;
    }
    .el-dialog--center .el-dialog__body {
        padding: 25px 25px 0;
    }
    .el-dialog__body {
        min-width: 35%;
        height: 50vh;
        overflow: auto;
    }
    .el-dialog__title {
        font-size: 16px;
    }
    .el-dialog__header {
        line-height: 40px;
        background-color: #f2f2f2;
        border-bottom: 1px solid #e6e6e6;
        font-size: 14px;
        color: #333;
        text-align: left;
        padding: 0 45px 0 15px;
    }
    .replace-dialog-title {
        border: 1px solid #e6e6e6;
        padding-left: 10px;
        margin-bottom: 15px;
        padding: 6px 14px;
    }
    .replace-dialog-title-p {
        width: 100% !important;
        font-size: 12px;
        margin: 10px 0;
    }
    .update-title-span {
        display: inline-block;
        width: 50%;
    }
    .el-form-item__label {
        font-size: 12px;
    }
    .el-radio {
        width: 100%;
        overflow: hidden;
        margin: 10px 0px;
    }
    .el-radio__label {
        font-size: 12px;
    }
}
</style>
